import React, { type PropsWithChildren } from 'react';

import { graphql, useFragment } from 'react-relay';

import { cssMap } from '@atlaskit/css';
import { Box, Inline } from '@atlaskit/primitives/compiled';

import type { withFieldLabel_AtlassianConversationAssistantPreviewCard$key as FieldConfigKey } from './__generated__/withFieldLabel_AtlassianConversationAssistantPreviewCard.graphql';
import { FieldLabel } from './field-label';

const styles = cssMap({
	labelContainer: {
		maxWidth: '40%',
		overflow: 'hidden',
	},
	labelTextStylesHorizontal: {
		display: 'block',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		width: '100%',
	},
	labelTextStylesVertical: {
		display: 'block',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		width: '100%',
	},
});

export const WithFieldLabel = ({
	fieldConfig,
	fallbackFieldName,
	children,
}: PropsWithChildren<{
	fieldConfig: FieldConfigKey | null;
	fallbackFieldName: string;
}>): React.JSX.Element => {
	const fieldConfigData = useFragment<FieldConfigKey>(
		graphql`
			fragment withFieldLabel_AtlassianConversationAssistantPreviewCard on JiraIssueField {
				...fieldLabel_AtlassianConversationAssistantPreviewCard
			}
		`,
		fieldConfig,
	);

	return (
		<Inline space="space.100" alignBlock="center">
			<Box xcss={styles.labelContainer}>
				<Box as="span" xcss={styles.labelTextStylesHorizontal}>
					<FieldLabel fallbackFieldName={fallbackFieldName} fieldConfig={fieldConfigData} />
				</Box>
			</Box>
			<Box>{children}</Box>
		</Inline>
	);
};
